module.exports = __webpack_public_path__ + "static/media/card-nuggets.fed7464f.png";